/* eslint-disable consistent-return */
import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
// import ResendMailGochiButton from '../atoms/ResendMailGochiButton';
// import ResendGochiButton from '../atoms/ResendGochiButton';
import ResendMailTextButton from '../atoms/ResendMailTextButton';
import ResendGochiTextButton from '../atoms/ResendGochiTextButton';
import RejectGochiTextButton from '../atoms/RejectGochiTextButton';

const styles = {};

const enhance = compose(pure);

const ShopTableBody = enhance(
  ({
    stripeChargeEvents,
    emptyRows,
    page,
    rowsPerPage,
    resendMailAction,
    resendGochiAction,
    rejectGochiAction
    // confirmOpenAction,
    // roles
  }) => {
    return (
      <TableBody>
        {stripeChargeEvents
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(result => {
            const paramsSendGochi = {
              id: result.id,
              merchantPaymentId: result.merchantPaymentId
            };
            const paramsSendMail = {
              id: result.id,
              merchantPaymentId: result.merchantPaymentId
            };
            const paramsRejectGochi = {
              id: result.id
            };
            return (
              <TableRow key={result.id}>
                <TableCell>{result.id}</TableCell>
                <TableCell>{result.chargeId || result.checkoutId}</TableCell>
                <TableCell>{result.customerEmail}</TableCell>
                <TableCell>{result.amount}</TableCell>
                <TableCell>{result.checkStatus}</TableCell>
                {/* <TableCell>{result.successUrl}</TableCell> */}
                <TableCell>{result.createdAt}</TableCell>
                <TableCell>{result.updatedAt}</TableCell>
                <TableCell>
                  {result.resendGochi && result.merchantPaymentId && (
                    <ResendMailTextButton
                      params={paramsSendMail}
                      onClickAction={resendMailAction}
                    />
                  )}
                </TableCell>
                <TableCell>
                  {result.merchantPaymentId && !result.resendGochi && (
                    <ResendGochiTextButton
                      params={paramsSendGochi}
                      onClickAction={resendGochiAction}
                    />
                  )}
                </TableCell>
                <TableCell>
                  <RejectGochiTextButton
                    params={paramsRejectGochi}
                    onClickAction={rejectGochiAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={9} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
